<div class="email-activation">
  <div class="container">
    @if (!isSuccess) {
      <div class="email-activation__content" >
        <div class="email-activation__failed">{{ errors }}</div>
      </div>
    }
    @if (isSuccess) {
      <div class="email-activation__content">
        <div class="email-activation__success">{{ 'EMAIL_VERIFICATION.SUCCESS' | translate }}</div>
      </div>
    }
  </div>
</div>

<app-footer></app-footer>

